import { render, staticRenderFns } from "./chart1.vue?vue&type=template&id=90292a60&scoped=true&"
import script from "./chart1.vue?vue&type=script&lang=js&"
export * from "./chart1.vue?vue&type=script&lang=js&"
import style0 from "./chart1.vue?vue&type=style&index=0&id=90292a60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90292a60",
  null
  
)

export default component.exports